import * as angular from 'angular';

import { TableListCellContentComponent } from './table-list-cell-content/table-list-cell-content.component';
import { TableListCellComponent } from './table-list-cell/table-list-cell.component';
import { TableListHeaderComponent } from './table-list-header/table-list-header.component';
import { TableListRowDropdownComponent } from './table-list-row-dropdown/table-list-row-dropdown.component';
import { TableListRowComponent } from './table-list-row/table-list-row.component';
import { TableListComponent } from './table-list.component';

/* prettier-ignore */
export const TableListModule = angular
  .module('table-list', [])
  .component('tableList', TableListComponent)
  .component('tableListHeader', TableListHeaderComponent)
  .component('tableListRow', TableListRowComponent)
  .component('tableListRowDropdown', TableListRowDropdownComponent)
  .component('tableListCell', TableListCellComponent)
  .component('tableListCellContent', TableListCellContentComponent)
  .name;
